import { Link } from 'react-router-dom';
import { getProductPath } from '../productUrls';
// Using CategoryCard.css instead 
import './CategoryCard.css';

const isPreOrderProduct = (product) => {
  const hasValidStock = (product.stockQuantity !== null && product.stockQuantity > 0);

  let hasVariantWithInvalidPrice = false;
  if (product.variants && product.variants.length > 0) {
    hasVariantWithInvalidPrice = product.variants.some(
      variant => variant.price === null || variant.price === undefined || variant.price <= 0
    );
  }

  const shouldBePreOrder = !hasValidStock ||
    hasVariantWithInvalidPrice ||
    ((!product.variants || product.variants.length === 0) &&
      (product.price === null || product.price === undefined || product.price <= 0));

  return shouldBePreOrder;
};

function ProductCard({ product, promoPrice }) {
  const showPreOrder = isPreOrderProduct(product);

  const discount = promoPrice && product.price && product.price > 0
    ? Math.min(99, Math.round((1 - promoPrice / product.price) * 100))
    : null;

  return (
    <div className="category-card">
      <Link to={getProductPath(product.productCode)} className="category-card-link">
        <div className="category-card-image-container">
          <img
            src={`${product.mainImageUrl}`}
            alt={product.name}
            className="category-card-image"
          />
          {showPreOrder && (
            <div className="category-card-preorder-badge">
              Pre-order
            </div>
          )}
          {discount > 0 && (
            <div className="category-card-promo-badge">
              -{discount}% OFF
            </div>
          )}
          <div className="category-card-overlay">
            <h3 className="category-card-title">{product.name}</h3>
            {promoPrice && (
              <div className="category-card-promo-price">
                <span className="category-card-original-price">RM {parseFloat(product.price).toFixed(2)}</span>
                <span className="category-card-sale-price">RM {parseFloat(promoPrice).toFixed(2)}</span>
              </div>
            )}
          </div>
        </div>
      </Link>
    </div>
  );
}

export default ProductCard;
